import { fillForm } from "./utils/helpers";
import Skeleton from "./components/Skeleton";
import { savePagesOrder } from "./utils/api";
import { getPages } from "../Pages/utils/api";
import { ErrorAlert, Header, Sortable, useFetchData } from "@";

const Index = () => {
  // Define navigation links
  const links = [{ name: "ترتيب عناصر الصفحة الرئيسية", link: "" }];

  // Fetch data using custom hook
  const { data, setData, isLoading, error, fetchData } = useFetchData({
    fun: getPages,
    setDataValue: true,
    fill: fillForm,
  });

  return (
    <>
      {/* Display error alert if there's an error */}
      <ErrorAlert reload={fetchData} show={error} />

      {/* Page header */}
      <Header title="ترتيب عناصر القائمة" links={links} />

      {/* Instruction and save button */}
      <div className="card mb-7 flex flex-col items-center justify-between gap-3 p-4 text-lg sm:flex-row">
        <p className="dark:text-gray-400">
          يمكنك ترتيب عناصر القائمة عبر السحب والإفلات
        </p>
        <button
          className="btn-purple-900 h-fit"
          onClick={() => savePagesOrder(data)}
        >
          حفظ
        </button>
      </div>

      {/* Display loading skeleton or sortable list */}
      {isLoading ? (
        <Skeleton />
      ) : (
        <Sortable data={data} set={setData} order={(items) => setData(items)} />
      )}
    </>
  );
};

export default Index;
